
<script>

var axios = require('axios');
var moment = require('moment');
var encryptor = require('simple-encryptor')
const crypto = require('crypto');
const { v4: uuid_v4 } = require('uuid');


let SERVER_URL = 'https://sys.parkaidemobile.com';
let BEE_INVOIS_URL = 'https://beeinvois.snatchpark.com/api';
let BEE_INVOIS_SERVICE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXJ2aWNlSWQiOjEsImlhdCI6MTcyNDc0Mzc1Mn0.GoS_OlThOUMUk-w9vh5hOvgVh2EgnU0vWYSGuazjYCg';
if(window.location.href.includes('localhost')) {
  SERVER_URL = 'https://sys2.parkaidemobile.com';
  BEE_INVOIS_URL = 'https://beeinvois.snatchpark.com/dev/api';
  BEE_INVOIS_SERVICE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXJ2aWNlSWQiOjMsImlhdCI6MTcyMzAxMTcwOH0.kbWc7MPP-x0tTNxMRpUQHCR2wWr25gQgKl5wp8Kr8a4';
}
if(window.location.href.includes('devpbill')) {
  SERVER_URL = 'https://sys2.parkaidemobile.com';
  BEE_INVOIS_URL = 'https://beeinvois.snatchpark.com/dev/api';
  BEE_INVOIS_SERVICE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXJ2aWNlSWQiOjMsImlhdCI6MTcyMzAxMTcwOH0.kbWc7MPP-x0tTNxMRpUQHCR2wWr25gQgKl5wp8Kr8a4';
}

let API_URL = '';
if(window.location.href.includes('localhost')) {
  API_URL = 'http://localhost:4000';
}
// const WEB_URL = '/v1';
const WEB_URL = '';




const IPAY_URL = 'https://payment.ipay88.com.my/epayment/entry.asp';
let IPAY_MERCHANT_CODE = 'M06494_S0003';
let IPAY_MERCHANT_KEY = 'Mmr74hC7Ix';
IPAY_MERCHANT_CODE = 'M33967_S0002';
IPAY_MERCHANT_KEY = 'Bzs1ZTqhgc';

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_TIME_FORMAT = 'HH:mm';
const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';


let formatMoney = function(amount) {
	if (amount === 0) {
		return '0.00';
	}

	if (!isNaN(amount)) {
		// main.js:1667 1.11
		// main.js:1669 111.00000000000001 < =_=
		// main.js:1671 112
		// main.js:1673 1.12
		// main.js:1675 1.12
		amount = amount * 100;
		amount = amount.toFixed(0);
		amount = amount >= 0 ? Math.ceil(amount) : Math.floor(amount);
		amount = amount / 100;
		amount = amount.toFixed(2);
		// amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return amount;
	}

	if (amount === '') {
		return '0.00';
	}

	return amount;
}

let formatFourPadLeftZero = function(number) {
  if (number <= 9999) {
		number = ("0000" + number).slice(-4);
	}
	return number;
}

let formatDate = function(datetime) {
  if(!datetime) {
    return '';
  }
  
  datetime = parseDateTime(datetime);
  return datetime ? datetime.format(DEFAULT_DATE_FORMAT) : datetime;
}

let formatTime = function(datetime) {
  if(!datetime) {
    return '';
  }
  
  datetime = parseDateTime(datetime);
  return datetime ? datetime.format(DEFAULT_TIME_FORMAT) : datetime;
}

let formatDateTime = function(datetime) {
  datetime = parseDateTime(datetime);
  return datetime ? datetime.format(DEFAULT_DATETIME_FORMAT) : datetime;
}

let parseDateTime = function(datetime) {
  if(datetime instanceof moment) {
    datetime = datetime;
  } else if(datetime instanceof Date) {
    datetime = moment(datetime);
  } else if(!isNaN(datetime)) {
    datetime = moment(datetime * 1000)
  } else if(datetime) {
    datetime = moment(datetime)
  } else {
    return datetime;
  }
  return datetime.isValid() ? datetime : null;
}

let getOneCalendarMonthLater = function(datetime) {
  let oneCalendarMonth = moment(parseDateTime(datetime))
  oneCalendarMonth.add(1, 'month')
  oneCalendarMonth.subtract(1, 'day');
  return oneCalendarMonth.startOf('day');
}

function uuidv4() {
  return uuid_v4()
  // return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
  //   (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  // )
}


let setSidebar = function(url) {
  // $('ul.nav li.active').removeClass('active')
  // $('ul.nav ul.in').removeClass('in')

  if(typeof url === 'string' && !url.startsWith('http')) {
    let href = window.location.href;
    let domain = href.substring(0, href.indexOf(window.location.pathname));
    url = domain + url;
  }

  // $('ul.nav a[href="'+ url +'"]').parent().addClass('active').parent().addClass('in').parent().addClass('active');
  let thirdLiSelector = $('ul.nav a').filter(function() {
    let index = url.href ? url.href.indexOf('#') : -1;
    if(index > 0) {
      return this.href == url.href.substring(0, index);
    }
    let index2 = url.href ? url.href.indexOf('?') : -1;
    if(index2 > 0) {
      return this.href == url.href.substring(0, index2);
    }
    return this.href == url;
  }).parent().addClass('active');
  let thirdUlSelector = thirdLiSelector.parent().addClass('in');
  let secondLiSelector = thirdUlSelector.parent().addClass('active');
  let secondUlSelector = secondLiSelector.parent().addClass('in');
  let firstUlSelector = secondUlSelector.parent().addClass('active');
}

let transformParamToMap = function(PARAM) {
  const PARAM_MAP = PARAM.reduce(function(result, item, index, array) {
    result[item.key || index] = item;
    item.form_hide |= false;
    return result;
  }, {});
  return PARAM_MAP;
}


let tableCustomEnableDisable = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) {
    return;
  }

  if(parseInt(dataItem[parameterItem.key])) {
    return '<span class="badge badge-sm badge-success">Enable</span>';
  } else {
    return '<span class="badge badge-sm badge-danger">Disable</span>';
  }
}

let tableCustomYesNo = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) {
    return;
  }

  if(dataItem[parameterItem.key] == true || parseInt(dataItem[parameterItem.key])) {
    return '<span class="badge badge-sm badge-success">Yes</span>';
  } else {
    return '<span class="badge badge-sm badge-danger">No</span>';
  }
}

let tableCustomDatetime = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) {
    return;
  }
  if(!dataItem[parameterItem.key]) {
    return '';
  }
  return formatDateTime(dataItem[parameterItem.key]);
}

let tableCustomDate = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) {
    return;
  }
  if(!dataItem[parameterItem.key]) {
    return '';
  }
  return formatDate(dataItem[parameterItem.key]);
}

let tableCustomMoney = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) {
    return;
  }
  
  return formatMoney(dataItem[parameterItem.key]);
}


let inputSelectSetOption = function(PARAM, options) {
  if(!checkRoleIsSuperadmin()) {
    if(PARAM['text'] && PARAM['text'].toLowerCase().startsWith('staff name')) {
      options = options.filter(k => k['name'] !== 'Admin')
    }
  }

  if(options && options.length > 1 && options[0]['createDate'] !== null && options[0]['createDate'] !== undefined) {
    options.sort((a, b) => b['createDate'] - a['createDate']);
  }

  if(PARAM.form_select.data) {
    PARAM.form_select.data = options;
    return;
  }
  PARAM.form_select = options;
}

let inputSelectFindOption = function(PARAM, selectedValue, selectionKey) {
  let formSelectTemp = PARAM.form_select.data || PARAM.form_select;
  return formSelectTemp.find(k => compareID(k[selectionKey || 'id'], selectedValue));
}


let compareID = function(a, b) {
  // when passed from router carparkID is int 1
  // when refresh in page carparkID is string "1"
  return String(a) === String(b);
}

let formatFourPadLeftZeroPLNum = function(number) {
	return number;
}

let plFormPVNum = function(licenseNum, carparkNum) {
  let text = 'PV-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLANum = function(licenseNum, carparkNum) {
  let text = 'PLA-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLTNum = function(licenseNum, carparkNum) {
  let text = 'PLT-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLPCNum = function(licenseNum, carparkNum) {
  let text = 'PC-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLAONum = function(licenseNum, carparkNum) {
  let text = 'PLAO-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLPPCNum = function(licenseNum, carparkNum) {
  let text = 'PPC-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLPRNum = function(licenseNum, carparkNum) {
  let text = 'PLPR-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormLDFNum = function(licenseNum, carparkNum) {
  let text = 'LDF-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormLAFNum = function(licenseNum, carparkNum) {
  let text = 'LAF-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPTPANum = function(licenseNum, carparkNum) {
  let text = 'PTPA-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPATPNum = function(licenseNum, carparkNum) {
  let text = 'PATP-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLNum = function(licenseNum, carparkNum) {
  let text = 'PL-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plFormPLREINum = function(licenseNum, carparkNum) {
  let text = 'REI-';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(licenseNum || 0);
  return text;
}

let plBillNum = function(billNum, carparkNum, type) {
  let text = '';
  if(type.endsWith('INV')) {
    text += 'INV';
  } else if(type.endsWith('CN')) {
    text += 'CN';
  } else if(type.endsWith('DN')) {
    text += 'DN';
  }
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(billNum || 0);
  return text;
}

let plORNum = function(orNum, carparkNum) {
  let text = 'OR';
  text += formatFourPadLeftZeroPLNum(carparkNum || 0) + '-';
  text += formatFourPadLeftZeroPLNum(orNum || 0);
  return text;
}

let plFormParker = function(parker, link) {
  if(!parker) return '';
  
  let temp = ''
  if(link) {
    temp += '<a href="#" onclick="event.preventDefault();">' + (parker['name'] || '') + '</a>';
  } else {
    temp += parker['name'] || '';
  }
  temp += '<br>';
  temp += parker['mobile'] || parker['username'] || '';
  temp += '<br>';
  temp += parker['car1'] || '';
  temp += '<br>';
  temp += parker['email'] || '';
  return temp;
}

let plPaymentRemark = function(licenseNum, carparkNum, carparkList) {
  let selectedCarpark = carparkList.find(k => compareID(k.id, carparkNum))
  let text = '';
  if(selectedCarpark) {
    let operatorID = selectedCarpark.operatorID || ''
    text += 'B' + operatorID + '-'
  } else {
    let meRoles = JSON.parse(localStorage.getItem('meRoles') || '[]');
    let roleID = localStorage.getItem('selectedRoleID');
    let customerID = localStorage.getItem('selectedCustomerID');
    let operatorID = localStorage.getItem('selectedOperatorID');
    let selectedRole = meRoles.find(k => compareID(k.roleID, roleID) && compareID(k.customerID, customerID) && compareID(k.operatorID, operatorID));

    if(selectedRole) {
      let operatorID = selectedRole.operatorID || ''
      text += 'B' + operatorID + '-'
    }
  }

  text += plFormPLNum(licenseNum, carparkNum);
  return text;
}


let addTokenToHeader = function(header) {
  try {
    header['x-access-token'] = JSON.parse(localStorage.getItem("user")).jwt;
  } catch(e) {

  }
  header['roleID'] = localStorage.getItem("selectedRoleID");
};

let appendSearchQuery = function(url, value) {
  if(value !== null && value !== undefined && value !== '') {
    url += (url.indexOf('?') > -1) ? '&' : '?';
    url += 'search=' + encodeURIComponent(value);
  }
  return url;
}

let appendPagingQuery = function(url, value) {
  if(value !== null && value !== undefined && value !== '') {
    url += (url.indexOf('?') > -1) ? '&' : '?';
    url += 'page=' + value;
  }
  return url;
}

let updateQueryString = function(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    var hash =  '';
    if( uri.indexOf('#') !== -1 ){
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
    }
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";    
    return uri + separator + key + "=" + value + hash;
  }
}


const CancelToken = axios.CancelToken;
let source;
let createAxiosConfig = function() {
  // TODO kw this make all request synchronous, optimize this!!
  if(source) {
    source.cancel('jt-axios-cancel');
  }
  source = CancelToken.source();

  var header = {};
  addTokenToHeader(header);

  var config = {};
  config['headers'] = header;
  config['cancelToken'] = source.token;
  return config;
};

let createAxiosFormConfig = function() {
  var header = {};
  addTokenToHeader(header);
  header['Content-Type'] = 'application/x-www-form-urlencoded';

  var config = {};
  config['headers'] = header;
  return config;
};

let processAxiosErrorString = function(error, key) {
  try {
    let message = key ? error.response.data[key] : error.response.data;
    if(message && typeof message === 'string') {
      return message;
    }
  } catch(e) {    
  }
}

let processAxiosErrorObject = (error, key) => {
  try {
    let message = key ? error.response.data[key] : error.response.data;
    if(message && typeof message === 'object') {
      return JSON.stringify(message);
    }
  } catch(e) {    
  }
}

let processAxiosResponse = (context, response, populatePaging, pagingTableRef) => {
  let temp = {};
  if(response.data.count !== null && response.data.count !== undefined && (response.data.result || response.data.record)) {
    temp.count = response.data.count;
    temp.page = Math.ceil(response.data.count / 100);
    response.data = response.data.result || response.data.record || [];
    
    if(populatePaging) {
      try {
        if(pagingTableRef) {
          pagingTableRef.setTotalPage(temp.page, temp.count);
        } else {
          context.$refs['pageTable'].setTotalPage(temp.page, temp.count);
        }
      } catch(e) {
      }
    }
  }
  return temp;
}

let parseAxiosError = (context, error) => {
  if (axios.isCancel(error)) {
    return error;
  }

  let errorMessage = processAxiosErrorString(error, 'message')
  if(errorMessage) {
    if(!error.response.data.auth) {
      setTimeout( () => context.$router.push({ path: '/logout'}), 2000);
    }
    return errorMessage;
  }

  let errorString = processAxiosErrorString(error, 'message')
    || processAxiosErrorString(error, 'detail')
    || processAxiosErrorString(error, 'code')
    || processAxiosErrorString(error, 'msg')
    || processAxiosErrorString(error, 'err')
    || processAxiosErrorString(error)
  if(errorString) {
    return errorString;
  }

  let errorObject = processAxiosErrorObject(error, 'message')
    || processAxiosErrorObject(error, 'detail')
    || processAxiosErrorObject(error, 'code')
    || processAxiosErrorObject(error, 'msg')
    || processAxiosErrorObject(error, 'err')
    || processAxiosErrorObject(error)
  if(errorObject) {
    return errorObject;
  }

  /*
  if(error) {
    if(error.response) {
      if(error.response.data) {
        if(error.response.data.message) {
          if(!error.response.data.auth) {
            setTimeout( () => context.$router.push({ path: '/logout'}), 2000);
          }
          return error.response.data.message;
        }
        if(error.response.data.detail) {
          return error.response.data.detail;
        }
        if(error.response.data.code) {
          return error.response.data.code;
        }
        if(error.response.data.msg) {
          return error.response.data.msg;
        }
        if(error.response.data.err) {
          return error.response.data.err;
        }
        return error.response.data;
      }
      return error.response;
    }
    return error;
  }
  */
  if(location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    console.error(error);
  }

  return 'Please try again.'
}

let parseAxiosErrorMessage = (context, error, action, identifier) => {
  let errorMsg = parseAxiosError(context, error);
  if(!axios.isCancel(errorMsg)) {
    return `Problem ${action || 'loading'} ${identifier || 'data'}. ${errorMsg}`;
  }

  return errorMsg;
}


let parseAddress = (response) => {
  try {
    let temp = response.data[0].address;
    if(temp.startsWith('"') && temp.endsWith('"')) {
      temp = temp.slice(1, -1);
    }
    temp = temp.replace(/\\\"/g, '"');
    temp = temp.replace(/\\/g, '');
    return JSON.parse(temp);
  } catch(e) {
    return {};
  }
}

let parseData = (response) => {
  try {
    let temp = response.data[0].data;
    if(temp.startsWith('"') && temp.endsWith('"')) {
      temp = temp.slice(1, -1);
    }
    temp = temp.replace(/\\\"/g, '"');
    return JSON.parse(temp);
  } catch(e) {
    return {};
  }
}

let parseContact = (response) => {
  try {
    let temp = response.data[0].contact;
    if(temp.startsWith('"') && temp.endsWith('"')) {
      temp = temp.slice(1, -1);
    }
    temp = temp.replace(/\\\"/g, '"');
    temp = temp.replace(/\\/g, '');
    return JSON.parse(temp);
  } catch(e) {
    return {};
  }
}

let getPermission = function(currentPage, debug) {
  debug = debug === undefined ? false : debug;
  if(debug) console.log('=====\ncurrentPage', currentPage);
  if(debug) console.log('currentPage.__file', currentPage.$route.matched[0].components.default.__file);
  if(debug) console.log('currentPage.name [' + currentPage.$route.matched[0].components.default.name + ']');
  let route;
  for(let k of router.routeList) {
    try {
      if(debug) console.log('k.component', k.component);
      if(debug) console.log('k.component.__file', k.component.__file);
      if(debug) console.log('k.component.name[' + k.component.name + ']');

      if(k.component.__file && currentPage.$route.matched[0].components.default.__file) {
        if(k.component.__file === currentPage.$route.matched[0].components.default.__file) {
          route = k;
          break;
        }
      }
      
      if(k.component.name && currentPage.$route.matched[0].components.default.name) {
        if(k.component.name === currentPage.$route.matched[0].components.default.name) {
          route = k;
          break;
        }
      }
    } catch(e) {
    }
  }
  route = route || {};
  let parameter = route.parameter || {};
  if(debug) console.log('page route', route, route.parameter, parameter.permission);
  if(debug) console.log('=====');
  return parameter.permission;
}

import router from '@/router'
let hasPermission = function(permission, debug) {
  if(checkRoleIsSuperadmin()) return true;

  debug = debug === undefined ? false : debug;
  // debug = true;
  if(debug) console.log('-----\npermission check', permission);
  if(!permission) {
    return true;
  }

  try {
    if(debug) console.log('permission meRoles', localStorage.getItem('meRoles'));
    let meRoles = JSON.parse(localStorage.getItem('meRoles') || '[]');
    if(debug) console.log('permission selected roleID', localStorage.getItem('selectedRoleID'));
    if(debug) console.log('permission selected customerID', localStorage.getItem('selectedCustomerID'));
    if(debug) console.log('permission selected operatorID', localStorage.getItem('selectedOperatorID'));
    let roleID = localStorage.getItem('selectedRoleID');
    let customerID = localStorage.getItem('selectedCustomerID');
    let operatorID = localStorage.getItem('selectedOperatorID');
    let selectedRole = meRoles.find(k => compareID(k.roleID, roleID) && compareID(k.customerID, customerID) && compareID(k.operatorID, operatorID));
    if(debug) console.log('permission selected role', selectedRole);
    let selectedRoleRules = JSON.parse(selectedRole.rules) || {};
    if(debug) console.log('permission selected role rules', selectedRoleRules);
    if(selectedRoleRules && selectedRoleRules[permission]) {
      if(debug) console.log('permission allow -', permission, '\n-----');
      return true;
    } else {
      if(debug) console.log('permission deny -', permission, '\n-----');
    }
  } catch(e) {
    if(debug) console.log('permission exception', e);
  }

  return false;
}

let hasViewPermission = function(permission, log) {
  if(checkRoleIsSuperadmin()) return true;
  if(permission === 'secretadmin') {
    return magic2(localStorage.getItem('salt')) === 'Superadmin'
    if(checkRoleIsSecretadmin()) {
      return true;
    } else {
      return false;
    }
  }

  if(!permission) return true;
  return hasPermission(permission + '.view', log)
}

let hasAddPermission = function(permission, log) {
  if(checkRoleIsSuperadmin()) return true;
  if(!permission) return true;
  return hasPermission(permission + '.add', log)
}

let hasEditPermission = function(permission, log) {
  if(checkRoleIsSuperadmin()) return true;
  if(!permission) return true;
  return hasPermission(permission + '.edit', log)
}

let hasDeletePermission = function(permission, log) {
  if(checkRoleIsSuperadmin()) return true;
  if(!permission) return true;
  return hasPermission(permission + '.remove', log)
}

let magic1 = function (text) {
  let user = JSON.parse(localStorage.getItem("user"));
  const cryptr = encryptor(magicKey(user));
  text = cryptr.encrypt(text);
  return text
}

let magic2 = function (text) {
  let user = JSON.parse(localStorage.getItem("user"));
  const cryptr = encryptor(magicKey(user));
  text = cryptr.decrypt(text);
  return text
}

let magicKey = function (user) {
  return user.jwt
}

// helper to replace router.push with window.location because vue-router is too unpredictable
let redirect = function(object, timeout) {
  // helper.redirect(helper.WEB_URL + '/internalRoleForm');
  // helper.redirect({ path: helper.WEB_URL + '/internalRoleForm', query: { roleID: tableData[tableDataIndex].id }});
  if(typeof object === 'string') {
    setTimeout(() => window.location = object, timeout || 0);
    return;
  }

  if(object.path && object.query) {
    let url = '';
    for(var key in object.query) {
      url += url ? '&' : '?';
      url += key + '=' + object.query[key];
    }
    setTimeout(() => window.location = object.path + url, timeout || 0);
    return;
  }
}


let setUser = async function(context, user) {
  let meRoles = await context.$http
    .get(
      SERVER_URL + '/api2/me/roles/',
      { headers : { 'x-access-token': user.jwt }}
    )
    .then(response => {
      return response.data;
    })
    .catch(error => {
      context.error = 'Problem logging in. ' + context.parseLoginError(error);
    })
  if(!meRoles || meRoles.length === 0) {
    context.error = 'Please check your email and verify your account.';
    return;
  }

  localStorage.setItem('user', JSON.stringify(user));
  if(await saveMeRoles(context, meRoles)) {
    if(meRoles.length === 1) {
      chooseRole(context, meRoles[0]);
    } else {
      chooseRole(context, meRoles[0], null, '/chooseAccount');
    }
  }
}

let saveMeRoles = async function(context, meRoles) {
  for(let k of meRoles) {
    k.customerID = k.customerID || 0;
    if(k.roleID === ROLE_PERSONAL_PARKER) {
      k.type = 'Parker';
      let result = await context.$http
        .get(
          SERVER_URL + '/api2/customer/',
          { 
            headers : 
            { 
              'x-access-token': JSON.parse(localStorage.getItem('user')).jwt,
              'roleID': k.roleID,
            }
          }
        )
        .then(response => {
          processAxiosResponse(context, response);
          if(response.data && response.data.length > 0) {
            return {
              result: true,
              customerID: response.data[0].id
            }
          } else {
            return {
              result: true,
              customerID: 0
            }}
        })
        .catch(error => {
          localStorage.removeItem('user');
          context.error = 'Problem loading profile. ' + context.parseLoginError(error);
        })

      if(!result || !result.result) {
        return false;
      }

      k.customerID = result.customerID
    } else if(k.roleID === ROLE_OPERATOR_SUPERADMIN) {
      k.type = 'Superadmin';
      k.rules = `{
        "title": 1,
        "entitlement.view": 1,
        "entitlement.add": 1,
        "entitlement.edit": 1,
        "carpark.view": 1,
        "carpark.add": 1,
        "carpark.edit": 1,
        "carpark.remove": 1,
        "carpark_level.view": 1,
        "carpark_level.add": 1,
        "carpark_level.edit": 1,
        "carpark_level.remove": 1,
        "carpark_zone.view": 1,
        "carpark_zone.add": 1,
        "carpark_zone.edit": 1,
        "carpark_zone.remove": 1,
        "carpark_zlevel.view": 1,
        "carpark_zlevel.add": 1,
        "carpark_zlevel.edit": 1,
        "carpark_zlevel.remove": 1,
        "carpark_street.view": 1,
        "carpark_street.add": 1,
        "carpark_street.edit": 1,
        "carpark_street.remove": 1,
        "carpark_bay.view": 1,
        "carpark_bay.add": 1,
        "carpark_bay.edit": 1,
        "carpark_bay.remove": 1,
        "product.view": 1,
        "product.add": 1,
        "product.edit": 1,
        "tenant.view": 1,
        "tenant.add": 1,
        "tenant.edit": 1,
        "tenant.remove": 1,
        "productfee.view": 1,
        "productfee.add": 1,
        "company.view": 1,
        "company.add": 1,
        "company.edit": 1,
        "company.remove": 1,
        "company_parker.view": 1,
        "company_parker.edit": 1,
        "personal.view": 1,
        "personal.add": 1,
        "personal.edit": 1,
        "personal.remove": 1,
        "personal_parker.view": 1,
        "personal_parker.edit": 1,
        "parkinglicense.view": 1,
        "parkinglicense_lease.view": 1,
        "parkinglicense_application.view": 1,
        "parkinglicense_application_pending.view": 1,
        "parkinglicense_addon.view": 1,
        "parkinglicense_addon_pending.view": 1,
        "parkinglicense_termination.view": 1,
        "parkinglicense_termination.add": 1,
        "parkinglicense_termination.edit": 1,
        "parkinglicense_pc.view": 1,
        "parkinglicense_pc.add": 1,
        "parkinglicense_ppc.view": 1,
        "parkinglicense_ppc.add": 1,
        "parkinglicense_ppc.edit": 1,
        "parkinglicense_reactivation.view": 1,
        "parkinglicense_reactivation.add": 1,
        "parkinglicense_reactivation.edit": 1,
        "passcard_type.view": 1,
        "passcard_type.add": 1,
        "passcard_type.edit": 1,
        "passcard_type.remove": 1,
        "passcard_all.view": 1,
        "passcard_all.add": 1,
        "passcard_all.edit": 1,
        "passcard_all.remove": 1,
        "passcard_issue.view": 1,
        "passcard_issue.edit": 1,
        "passcard_termination_return.view": 1,
        "passcard_termination_return.edit": 1,
        "passcard_lostdamagafaulty.view": 1,
        "passcard_lostdamagafaulty.edit": 1,
        "passcard_return.view": 1,
        "passcard_return.edit": 1,
        "passcard_blockunblock.view": 1,
        "passcard_blockunblock.edit": 1,
        "refund_management.view": 1,
        "refund_management.edit": 1,
        "collection_bill.view": 1,
        "collection_bill.edit": 1,
        "bill_management.view": 1,
        "adminstration.view": 1,
        "adminstration.add": 1,
        "adminstration.edit": 1,
        "adminstration.remove": 1,
        "report.view": 1,
        "id": 1,
        "dashboard.view": 1,
        "passcard_lostandfound.view": 1,
        "passcard_lostandfound.edit": 1,
        "parkinglicense_application.void": 1,
        "parkinglicense_application.approve": 1,
        "parkinglicense_application.reject": 1,
        "parkinglicense_application_pending.void": 1,
        "parkinglicense_application_pending.approve": 1,
        "parkinglicense_application_pending.reject": 1,
        "parkinglicense_pc.approve": 1,
        "parkinglicense_pc.reject": 1,
        "parkinglicense_pc.void": 1,
        "parkinglicense_application.add": 1,
        "parkinglicense_application.edit": 1,
        "parkinglicense_application_pending.add": 1,
        "parkinglicense_application_pending.edit": 1,
        "parkinglicense_addon.add": 1,
        "parkinglicense_addon.edit": 1,
        "parkinglicense_addon_pending.add": 1,
        "parkinglicense_addon_pending.edit": 1,
        "parkinglicense_pc.edit": 1,
        "passcard_termination_return.add": 1,
        "passcard_lostdamagafaulty.add": 1,
        "passcard_fromparkaide.view": 1,
        "passcard_fromparkaide.add": 1,
        "passcard_fromparkaide.edit": 1,
        "passcard_toparkaide.edit": 1,
        "passcard_toparkaide.add": 1,
        "passcard_toparkaide.view": 1,
        "parkinglicense_addon.approve": 1,
        "parkinglicense_addon.reject": 1,
        "parkinglicense_addon.void": 1,
        "parkinglicense_addon_pending.approve": 1,
        "parkinglicense_addon_pending.reject": 1,
        "parkinglicense_addon_pending.void": 1,
        "passcard_lostandfound.add": 1,
        "parkinglicense_reinstatement.view": 1,
        "parkinglicense_reinstatement.add": 1,
        "parkinglicense_reinstatement.edit": 1,
        "productfee.activate": 1,
        "productfee.remove": 1,
        "1": 1
      }`
    } else {
      k.type = 'Internal User';
    }
  };
  meRoles = meRoles.sort((a,b) => b.roleID === ROLE_PERSONAL_PARKER ? 1 : -1);

  localStorage.setItem('meRoles', JSON.stringify(meRoles));
  return true;
}

let chooseRole = async function(context, role, reload, redirectPath) {
  localStorage.setItem('selectedRoleID', role.roleID);
  localStorage.setItem('salt', magic1(role.type || ''));
  localStorage.setItem('selectedCustomerID', role.customerID);
  localStorage.setItem('selectedOperatorID', role.operatorID);

  if(checkRoleIsParker()) {
    let parkerRules = createParkerRules();
    let meRoles = JSON.parse(localStorage.getItem('meRoles'));
    let currentRole = meRoles.find(k => compareID(k.roleID, role.roleID));
    if(currentRole) {
      currentRole.rules = JSON.stringify(parkerRules);
    }
    localStorage.setItem('meRoles', JSON.stringify(meRoles));
  }

  if(reload) {
    location.reload();
  } else {
    let defaultRedirect = role.rules.includes('dashboard') ? '/dashboard' : '/landing';
    defaultRedirect = role.rules.includes('dashboard') ? '/dashboard' : '/';
    redirect(redirectPath || defaultRedirect, window.location.href.includes('localhost/login') ? 1000 : 0);
  }
}

let createParkerRules = function() {
  let parkerRules = {};
  if(checkRoleHasCustomerID()) {
  // if(true) {
    parkerRules["parkinglicense.view"] = 1;
    parkerRules["parkinglicense_lease.view"] = 1;
    parkerRules["parkinglicense_application.view"] = 1;
    parkerRules["parkinglicense_application.add"] = 1;
    parkerRules["parkinglicense_addon.view"] = 1;
    parkerRules["parkinglicense_addon.add"] = 1;
    parkerRules["parkinglicense_ppc.view"] = 1;
    parkerRules["parkinglicense_ppc.add"] = 1;
    parkerRules["parkinglicense_pc.view"] = 1;
    parkerRules["parkinglicense_pc.add"] = 1;
    parkerRules["parkinglicense_termination.view"] = 1;
    parkerRules["parkinglicense_termination.add"] = 1;
    parkerRules["parkinglicense_termination.edit"] = 1;
    parkerRules["collection_bill.view"] = 1;
    parkerRules["collection_transaction.view"] = 1;
    parkerRules["collection_receipt.view"] = 1;
    parkerRules["bill_management.view"] = 1;
    parkerRules["payment_voucher.view"] = 1;
  }
  parkerRules["company.view"] = 1;
  parkerRules["company.add"] = 1;
  parkerRules["company.edit"] = 1;
  parkerRules["company_parker.edit"] = 1;
  parkerRules["personal.view"] = 1;
  parkerRules["personal.add"] = 1;
  parkerRules["personal.edit"] = 1;
  parkerRules["personal_parker.edit"] = 1;
  return parkerRules;
}

const ROLE_PERSONAL_PARKER = 20000;
const ROLE_COMPANY_PARKER = 20000;
const ROLE_OPERATOR_SUPERADMIN = 30000;
let checkRoleIsParker = function() {
  let currentRoleType = localStorage.getItem('salt');
  currentRoleType = magic2(currentRoleType)
  if(currentRoleType === 'Parker' || currentRoleType === 'Personal' || currentRoleType === 'Company') {
    return true;
  }
}

let checkRoleIsSuperadmin = function() {
  let currentRoleType = localStorage.getItem('salt');
  currentRoleType = magic2(currentRoleType)
  if(currentRoleType === 'Superadmin') {
    return true;
  }
}

let checkRoleIsCompany = function() {
  let currentRoleType = localStorage.getItem('salt');
  currentRoleType = magic2(currentRoleType)
  // if(currentRoleType === 'Personal') {
  //   return false;
  // }
  if(currentRoleType === 'Company') {
    return true;
  }
  // let currentCustomerID = localStorage.getItem('selectedCustomerID');
  // if(currentCustomerID && currentCustomerID !== '0') {
  //   return true;
  // }
}

let checkRoleHasCustomerID = function() {
  // // TODO pretend already created profile
  // if(location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  //   return true;
  // }

  let currentCustomerID = localStorage.getItem('selectedCustomerID');
  if(currentCustomerID && currentCustomerID !== '0') {
    return true;
  }
}

let checkRoleIsSecretadmin = function() {
  let currentRoleID = localStorage.getItem('selectedRoleID');
  if(compareID(currentRoleID, 10019)) {
    return true;
  }
}


// iPay
let iPaySHA256 = function(s){
	var chrsz   = 8;
	var hexcase = 0;
 
	function safe_add (x, y) {
		var lsw = (x & 0xFFFF) + (y & 0xFFFF);
		var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
		return (msw << 16) | (lsw & 0xFFFF);
	}
 
	function S (X, n) { return ( X >>> n ) | (X << (32 - n)); }
	function R (X, n) { return ( X >>> n ); }
	function Ch(x, y, z) { return ((x & y) ^ ((~x) & z)); }
	function Maj(x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)); }
	function Sigma0256(x) { return (S(x, 2) ^ S(x, 13) ^ S(x, 22)); }
	function Sigma1256(x) { return (S(x, 6) ^ S(x, 11) ^ S(x, 25)); }
	function Gamma0256(x) { return (S(x, 7) ^ S(x, 18) ^ R(x, 3)); }
	function Gamma1256(x) { return (S(x, 17) ^ S(x, 19) ^ R(x, 10)); }
 
	function core_sha256 (m, l) {
		var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);
		var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
		var W = new Array(64);
		var a, b, c, d, e, f, g, h, i, j;
		var T1, T2;
 
		m[l >> 5] |= 0x80 << (24 - l % 32);
		m[((l + 64 >> 9) << 4) + 15] = l;
 
		for ( var i = 0; i<m.length; i+=16 ) {
			a = HASH[0];
			b = HASH[1];
			c = HASH[2];
			d = HASH[3];
			e = HASH[4];
			f = HASH[5];
			g = HASH[6];
			h = HASH[7];
 
			for ( var j = 0; j<64; j++) {
				if (j < 16) W[j] = m[j + i];
				else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
 
				T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
				T2 = safe_add(Sigma0256(a), Maj(a, b, c));
 
				h = g;
				g = f;
				f = e;
				e = safe_add(d, T1);
				d = c;
				c = b;
				b = a;
				a = safe_add(T1, T2);
			}
 
			HASH[0] = safe_add(a, HASH[0]);
			HASH[1] = safe_add(b, HASH[1]);
			HASH[2] = safe_add(c, HASH[2]);
			HASH[3] = safe_add(d, HASH[3]);
			HASH[4] = safe_add(e, HASH[4]);
			HASH[5] = safe_add(f, HASH[5]);
			HASH[6] = safe_add(g, HASH[6]);
			HASH[7] = safe_add(h, HASH[7]);
		}
		return HASH;
	}
 
	function str2binb (str) {
		var bin = Array();
		var mask = (1 << chrsz) - 1;
		for(var i = 0; i < str.length * chrsz; i += chrsz) {
			bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i%32);
		}
		return bin;
	}
 
	function Utf8Encode(string) {
		string = string.replace(/\r\n/g,"\n");
		var utftext = "";
 
		for (var n = 0; n < string.length; n++) {
 
			var c = string.charCodeAt(n);
 
			if (c < 128) {
				utftext += String.fromCharCode(c);
			}
			else if((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			}
			else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}
 
		}
 
		return utftext;
	}
 
	function binb2hex (binarray) {
		var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
		var str = "";
		for(var i = 0; i < binarray.length * 4; i++) {
			str += hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8+4)) & 0xF) +
			hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8  )) & 0xF);
		}
		return str;
	}
 
	s = Utf8Encode(s);
	return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
}

let iPayHMACSHA256 = function(s, key){
  const hmac = crypto.createHmac('sha512', key);
  hmac.update(s);
  return hmac.digest('hex');
}

let convertPaymentMethod = function(paymentMethod) {
  if(!paymentMethod) {
    return '';
  }

  let paymentMethodLower = paymentMethod.toLowerCase();
  if(paymentMethodLower === 'cash') {
    return 'Cash';
  } else if(paymentMethodLower === 'check') {
    return 'Cheque';
  } else if(paymentMethodLower === 'giro') {
    return 'Giro';
  } else {
    return paymentMethod.charAt(0).toUpperCase() + paymentMethod.slice(1);
  }
}

let convertPaymentStatus = function(status) {
  if(!status) {
    return '';
  }

  let statusLower = status.toLowerCase();
  if(statusLower === 'new') {
    return 'New';
  } else if(statusLower === 'paid') {
    return 'Paid';
  } else if(statusLower === 'pending') {
    return 'Pending Authorization';
  } else if(statusLower === 'cancel') {
    return 'Cancel';
  } else {
    return status.charAt(0).toUpperCase() + status.slice(1);
  }
}

export default {
  API_URL,
  SERVER_URL,
  WEB_URL,

  BEE_INVOIS_URL,
  BEE_INVOIS_SERVICE_TOKEN,

  IPAY_URL,
  IPAY_MERCHANT_CODE,
  IPAY_MERCHANT_KEY,

  DEFAULT_DATE_FORMAT,

  formatFourPadLeftZero,
  formatMoney,
  formatDate,
  formatTime,
  formatDateTime,
  parseDateTime,
  getOneCalendarMonthLater,

  uuidv4,
  
  setSidebar,

  transformParamToMap,

  tableCustomEnableDisable,
  tableCustomYesNo,
  tableCustomDatetime,
  tableCustomDate,
  tableCustomMoney,

  inputSelectSetOption,
  inputSelectFindOption,

  compareID,

  plFormPVNum,
  plFormPLANum,
  plFormPLTNum,
  plFormPLPCNum,
  plFormPLAONum,
  plFormPLPPCNum,
  plFormPLPRNum,
  plFormLDFNum,
  plFormLAFNum,
  plFormPTPANum,
  plFormPATPNum,
  plFormPLREINum,
  plFormPLNum,
  plBillNum,
  plORNum,
  plFormParker,
  plPaymentRemark,

  addTokenToHeader,
  appendSearchQuery,
  appendPagingQuery,
  updateQueryString,
  createAxiosConfig,
  createAxiosFormConfig,
  processAxiosResponse,
  parseAxiosError,
  parseAxiosErrorMessage,

  parseAddress,
  parseContact,
  parseData,

  setUser,
  getPermission,
  hasPermission,
  hasViewPermission,
  hasAddPermission,
  hasEditPermission,
  hasDeletePermission,

  redirect,

  createParkerRules,
  chooseRole,
  checkRoleIsParker,
  checkRoleIsSuperadmin,
  checkRoleIsCompany,
  checkRoleHasCustomerID,
  checkRoleIsSecretadmin,

  iPaySHA256,
  iPayHMACSHA256,

  convertPaymentMethod,
  convertPaymentStatus,
};
</script>


// WEBPACK FOOTER //
// src/components/Utility/Helper.vue